// 判读是否可以新增其他项目
export function canAddOtherItems(orderType, orderStatus) {
  return (orderType === 'service') && ['unconfirmed_other', 'not_wear_armband_notice', 'not_hold_wear_armband_ceremony',
    'not_prepare_provide_food_ceremony', 'not_first_night_watching', 'unconfirmed_director_work',
    'unconfirmed_life_info', 'not_hold_libation_box_ceremony', 'not_second_night_watching',
    'not_hold_be_thankful_ceremony', 'not_meal','not_settlement', 'processing'].includes(orderStatus)
}
